import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useRecoilValue } from 'recoil';
import { LocaleContext } from '@zurich/common/contexts';
import { useTranslation } from '@zurich/common/hooks';
import { SummarySection } from '@zurich/ui/legacy/components';
import { offerDetailsAtom } from '../../../recoil/atoms/policy';
export function PolicyDetailInsuranceDatesSummary() {
    const { t } = useTranslation();
    const locale = useContext(LocaleContext);
    const { formatDate } = locale;
    const offer = useRecoilValue(offerDetailsAtom);
    const insuranceDatesData = [
        {
            label: t('policy.insuranceStartDate'),
            value: offer.insuranceStartDate && formatDate(offer.insuranceStartDate),
        },
        {
            label: t('policy.generalDetailInsuranceEndDate'),
            value: offer.insuranceEndDate && formatDate(offer.insuranceEndDate),
        },
        // TODO: Model does not have a 'mainDueDate' property yet
        // {
        //   label: t('policy.nextDueDate'),
        //   value: formatDate(offer.mainDueDate),
        // },
        {
            label: t('policy.cancelationDate'),
            value: offer.insuranceCancelationDate &&
                formatDate(offer.insuranceCancelationDate),
        },
    ];
    return (_jsx(SummarySection, { rows: insuranceDatesData, title: `${t('policy.insuranceStartDate')} – ${t('policy.generalDetailInsuranceEndDateTitle')}`, editable: false }));
}
